import { Action } from '@ngrx/store';
import { BuildingDetails } from '../models/buildingDetails.model';

// Define action types
export const ADD_BUILDING_DETAILS = '[Building] Add Details';
export const ADD_BUILDING_DETAILS_MANAGER = '[Building] Add Details Manager';
export const RETRIVE_DETAILS = '[Building] Retrieve Details';
export const UPDATE_BUILDING_UNITS = '[Building] Update Units';
export const UPDATE_BUILDING_DETAILS = '[Building] Update Details';
export const DELETE_BUILDING_DETAILS = '[Building] Delete Details';
export const BUILDING_RESET = '[Building] Reset';

// Create classes for each action
export class AddBuildingDetails implements Action {
  readonly type = ADD_BUILDING_DETAILS;
  constructor(public payload: BuildingDetails) {}
}

export class AddBuildingDetailsManager implements Action {
  readonly type = ADD_BUILDING_DETAILS_MANAGER;
  constructor(public payload: BuildingDetails) {}
}

export class RetrieveDetails implements Action {
  readonly type = RETRIVE_DETAILS;
  constructor(public payload: BuildingDetails) {}
}

export class UpdateBuildingUnits implements Action {
  readonly type = UPDATE_BUILDING_UNITS;
  constructor(public payload: any) {}
}

export class UpdateBuildingDetails implements Action {
  readonly type = UPDATE_BUILDING_DETAILS;
  constructor(public payload: { unit_number: number; updatedBuilding: BuildingDetails }) {}
}

export class DeleteBuildingDetails implements Action {
  readonly type = DELETE_BUILDING_DETAILS;
  constructor(public payload: { unit_number: number }) {}
}

export class BuildingReset implements Action {
  readonly type = BUILDING_RESET;
  constructor(public payload: any) {}
}

// Export action types as a union
export type BuildingActions =
  | AddBuildingDetails
  | AddBuildingDetailsManager
  | RetrieveDetails
  | UpdateBuildingUnits
  | UpdateBuildingDetails
  | DeleteBuildingDetails
  | BuildingReset;
